import { DeviceFilterParams, getDevice, getDevices } from '../../api/devices';
import { Device } from '../../interfaces/api/device';

export async function fetchDevices(params: DeviceFilterParams): Promise<Device[]> {
	try {
		return await getDevices(params);
	} catch (error) {
		throw error;
	}
}

export async function fetchDevice(id: number, params: DeviceFilterParams): Promise<Device> {
	try {
		return await getDevice(id, params);
	} catch (error) {
		throw error;
	}
}
